<template lang="pug">
  #footer
    .container
      .footer_con
        .footer_logo
          img(src="@/assets/img/tap_logo.png")
        .footer_font
          .font_right
            .font_right_li 
              img(src="@/assets/img/bottom_wxgzh.png")
              p 微信公众号
            .font_right_li 
              img(src="@/assets/img/bottom_wxqy_n.png")
              p 官方客服
        .font_middle
          p 邮箱：ciweianquan@ciwei.com
          p 地址：湖南省长沙市岳麓区麓谷企业广场E1栋1单元
          p 联系电话：17570769541 蒋女士
        p.copy 
          | 湖南刺猬安全科技有限公司
          span 版权所有
        p
          a(href="https://beian.miit.gov.cn/" target="_blank") 湘ICP备19002762号-1
</template>
<script>
export default {
  name: "Footer2",
  data() {
    return {
      navList_left: [
        {
          name: "首页",
          path: "/",
          children: []
        },
        {
          name: "信息预警",
          path: "/informationwarning",
          children: []
        },
        {
          name: "海外安全",
          path: "/overseassecurity",
          children: []
        }
      ],
      navList_right: [
        {
          name: "商贸服务",
          path: "/investmentcommerce",
          children: []
        },
        {
          name: "海外社群",
          path: "/overseascommunities",
          children: []
        },
        {
          name: "关于我们",
          path: "/aboutus",
          children: []
        }
      ]
    }
  }
};
</script>
<style lang="scss" scoped>
#footer {
  width: 100%;
  color: #fff;
  background: #1A2D4D;
  overflow: hidden;
  text-align: center;
  .footer_con {
    .footer_logo {
      padding: 14px 0;
      border-bottom: 1px solid #466084;
      img {
        width: 98px;
      }
    }
    .footer_font {
      width: 100%;
      border-bottom: 1px solid #466084;
      .font_right {
        display: flex;
        justify-content: space-between;
        width: 190px;
        margin: 0 auto;
        margin-top: 18px;
        .font_right_li {
          width: 83px;
          img {
            width: 100%;
          }
          p {
            margin-top: 5px;
            font-size: 12px;
          }
        }
      }
    }
    .font_middle {
      width: 100%;
      margin-top: 11px;
     
      border-bottom: 1px solid #466084;
      p {
        text-align: left;
        font-size: 12px;
      }
    }
  }
}
.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 12px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 12px;
}
.copy {
  color: #ffffff;
  font-size: 12px;
  margin: 10px 0 4px;
  font-weight: 400;
  span {
    margin-left: 15px;
  }
}
p {
  a {
    color: #fff;
    text-decoration: none;
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer2.vue